import * as actions from "Actions";
import * as api from "Api";

export const fetchValuationSuggestions = () => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    return dispatch(
      actions.getValuationSuggestions(
        api.getValuationSuggestions(currentOrganization.id)
      )
    );
  };
};

export const updateValuationSettings = (valuationId, labels) => (
  dispatch,
  getState
) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.updateValuationSettings(
      api.updateValuationSettings({
        organization: currentOrganization.id,
        id: valuationId,
        labels: labels
      })
    )
  );
};

export const deleteValuationSettings = (valuationId, isForced) => (
  dispatch,
  getState
) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.deleteValuationSettings(
      api.deleteValuationSettings({
        organization: currentOrganization.id,
        isForced: isForced,
        id: valuationId
      })
    )
  );
};

export const saveValuationSettings = labels => (dispatch, getState) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.saveValuationSettings(
      api.saveValuationSettings({
        organization: currentOrganization.id,
        labels: labels
      })
    )
  );
};



// WEBPACK FOOTER //
// ./src/actions/thunks/valuation.js